import React, { Component } from 'react';

class Panel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
    };
  }

  render() {
    const { products, name, activeTab, index, activateTab } = this.props;
    const isActive = activeTab === index;
    const innerStyle = {
      height: isActive ? `auto` : '0px',
    };

    return (
      <div className={`panel menu-item-${this.props.color}`} role="tabpanel" aria-expanded={isActive}>
        <button className="panel-label" role="tab" onClick={activateTab}>
          {name}
        </button>
        <div className="panel-inner" style={innerStyle} aria-hidden={!isActive}>
          {products.map(product => (
            <div key={product._id} className="row m-2">
              <span className={`${product.price > 0 ? 'col-9' : 'col-12'} text-left`}>{product.name}</span>
              {product.price > 0 && <span className="col-3 text-right txt-bold">{`${product.price}TND`}</span>}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/Panel.js